import { ChangeEvent, FC, FocusEventHandler, memo } from 'react'
import { PlanningApplicationStatus } from '@leadgen/models/client'
import { CheckboxButton } from '../../../atoms/CheckboxButton'
import useStableCallback from '../../../../hooks/shared/useStableCallback'

const planningApplicationStatusMap: Record<
  PlanningApplicationStatus,
  { title: string; description: string }
> = {
  submitted: {
    title: 'When submitted',
    description:
      'Send when applications are submitted to the local authority, before a decision is made.',
  },
  approved: {
    title: 'When approved',
    description: 'Send when applications are approved by the local authority.',
  },
}

const ApplicationStatusTile: FC<{
  planningApplicationStatus: PlanningApplicationStatus
  selected: boolean
  onChange: (event: ChangeEvent<HTMLInputElement>) => void
  onBlur?: FocusEventHandler<HTMLButtonElement>
}> = ({ planningApplicationStatus, selected, onChange: baseOnChange, onBlur }) => {
  const onChange = useStableCallback(() => {
    baseOnChange({
      target: { value: planningApplicationStatus },
    } as React.ChangeEvent<HTMLInputElement>)
  })
  return (
    <CheckboxButton
      onBlur={onBlur}
      onChange={onChange}
      value={planningApplicationStatus}
      checked={selected}
      label={planningApplicationStatusMap[planningApplicationStatus].title}
      tooltip={planningApplicationStatusMap[planningApplicationStatus].description}
    />
  )
}

export default memo(ApplicationStatusTile)
